// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"dca2f9be","158":"db1e9fd9"}[chunkId] + ".chunk.css";
};